import { useState, useEffect } from 'react';
import { isBefore, startOfDay } from 'date-fns';

import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import { sanityClient } from '@dashboard/lib/sanity/client';
import useUserQueries from '@dashboard/hooks/queries/useUserQueries';

export function useUpdateNotification() {
  const [hasNewUpdates, setHasNewUpdates] = useState(false);
  const { user, setUser } = useAuth();
  const { updateUser } = useUserQueries();

  useEffect(() => {
    const checkForUpdates = async () => {
      const latestUpdate = await sanityClient.fetch(
        `*[_type == "changelog-entry"] | order(date desc)[0]{ date }`,
      );

      if (latestUpdate) {
        const latestUpdateDate = startOfDay(new Date(latestUpdate.date));

        if (user?._id) {
          const userLastChecked = user.closedChangelogAt
            ? startOfDay(new Date(user.closedChangelogAt))
            : null;

          setHasNewUpdates(!userLastChecked || isBefore(userLastChecked, latestUpdateDate));
        }
      }
    };

    checkForUpdates();
  }, [user]);

  const markUpdatesAsSeen = async () => {
    const closedChangelogAt = new Date();
    const { data } = await updateUser({ closedChangelogAt }, user._id);
    setUser(data);
    setHasNewUpdates(false);
  };

  return { hasNewUpdates, markUpdatesAsSeen };
}
